import styled from '@emotion/styled'

import Badge from '@segment/matcha/components/Badge'
import Button from '@segment/matcha/components/Button'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import Typography from '@segment/matcha/components/Typography'

import CardBase, * as Card from '@segment/matcha/recipes/Card'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import { trackButtonClick } from '@segment/tracking/scripts'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  button: {
    text: `Get a demo`,
    href: `/demo/`,
  },
  cards: [
    {
      badge: `Engage`,
      heading: `Audiences & profile enrichment`,
      description: `Enhance every customer experience with profile, audience, and event data from the warehouse.`,
    },
    {
      badge: `Engage`,
      heading: `AI-recommended audiences`,
      description: `Build more targeted audiences based on AI-powered product recommendations designed to drive conversions. `,
    },
  ],
}

const Addons = () => {
  const pageConfig = usePageConfig()

  return (
    <Wrapper>
      <StyledSectionBase variant="centered">
        <Title variant="h2">Add-ons</Title>
        <StyledColumnTrack columns={1} overrides={{ lg: 2 }}>
          {copy.cards.map((copy) => (
            <CardBase key={copy.heading}>
              <CardBody>
                <Card.Copy>
                  <Card.Label>
                    <Badge variant="outlined">{copy.badge}</Badge>
                  </Card.Label>
                  <Card.Headline tag="h2" variant="h3">
                    {copy.heading}
                  </Card.Headline>
                  <Card.Description variant="pMedium">{copy.description}</Card.Description>
                </Card.Copy>
              </CardBody>
            </CardBase>
          ))}
        </StyledColumnTrack>
        <Button
          variant="filled"
          color="primary"
          size="medium"
          href={getAbsoluteUrl(copy.button.href, pageConfig)}
          onClick={() =>
            trackButtonClick({
              buttonText: copy.button.text,
              targetUrl: copy.button.href,
              buttonId: `pricing-cdp-page-add-ons-section-demo`,
            })
          }
        >
          {copy.button.text}
        </Button>
      </StyledSectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.header``

const Title = styled(Typography)`
  margin: 0;
`

const StyledColumnTrack = styled(ColumnTrack)`
  max-width: 844px;
`

const CardBody = styled(Card.Body)`
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding: 56px;
  }
`

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 40px;

    ${({ theme }) => theme.breakpoints.up(`md`)} {
      padding: 80px;
    }
  }
`

export default Addons
